import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IdentificationMethod } from '../../../shared/enums/identification-method.enum';

@Component({
  selector: 'form-identification',
  templateUrl: './identification.component.html',
  styleUrls: ['./identification.component.scss'],
})
export class IdentificationComponent implements OnInit, OnDestroy {
  protected destroyed: Subject<void> = new Subject<void>();
  @Output() beforeLogin: EventEmitter<void> = new EventEmitter<void>();
  @Input() overrideWithoutEidText?: string;

  @Input() overrideIdentityCardFrontHint?: string;
  @Input() overrideIdentityCardBackHint?: string;

  public readonly IdentificationMethod = IdentificationMethod;
  @Input() public formGroup: UntypedFormGroup;
  @Input() public isLogged: boolean;
  @Input() additionalRepresentative: boolean = false;

  @Input() hideIdentificationWithoutIDP: boolean = false;
  @Input() filterProviders: boolean = false;

  constructor() {}

  async ngOnInit(): Promise<void> {
    if (this.additionalRepresentative) {
      this.formGroup.get("identificationMethod")?.setValue(IdentificationMethod.WITHOUT_IDENTITY_PROVIDER);
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  onLogin() {    
    this.beforeLogin.next();
  }

  public identificationMethodChanges(event: MatRadioChange) {
    switch(event.value) {
      case IdentificationMethod.WITH_IDENTITY_PROVIDER:
        this.formGroup.get('identityCardFront')!.reset();
        this.formGroup.get('identityCardBack')!.reset();
        break;
    }
  }
}
